import '/app/brewery-packages/content/content-editor-plugin-ordered-list/src/OrderedList.css-raw';
export default {
  "orderedList": "about-us-b998e096-orderedList-Gei3fa"
};